import React from 'react';

class Blank extends React.Component {
  render() {
    return null;
  }
}

export default Blank;



// WEBPACK FOOTER //
// ./src/js/templates/blank.js